import React, { Component } from "react";
import { Icon, Button, Image, Grid } from 'semantic-ui-react';
import { withRouter} from 'react-router-dom';


class TractorItem extends Component {

  render() {

    return (
      <Grid.Column width={6}>
        <div className="tractor-item">
          <img src={this.props.img} alt="tractor"/>
          <div className="tractor-item-text">
            <span>{this.props.series}</span>
            <h3>{this.props.tractor}</h3>
          </div>
          <Button href={this.props.link} fluid>{this.props.packageBtn ? this.props.packageBtn : "Buy This Package"}</Button>
        </div>
      </Grid.Column>
    );
  }

};

export default withRouter(TractorItem);



// WEBPACK FOOTER //
// ./src/components/TractorItem/index.js